// extracted by mini-css-extract-plugin
module.exports = {"requireditem":"RequiredProductItem_requireditem__38ZzY"};